export const compatibleAgentsFields = `compatibleAgents($locator(count:16),count),compatibleCloudImages($locator(count:16),count)`
